import React from 'react';
import styled from 'styled-components';

interface Props {
  percent: number; // 0-100
  size?: number; // default 24
}

const TaskCompletionCircle: React.FC<Props> = ({ percent, size = 24 }) => {
  const radius = size / 2 - 3;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percent / 100) * circumference;

  return (
    <Wrapper style={{ width: size, height: size }}>
      <svg width={size} height={size}>
        {percent < 100 ? (
          <>
            <circle
              cx={size / 2}
              cy={size / 2}
              r={radius}
              stroke="#ccc"
              strokeWidth="6"
              fill="none"
            />
            <circle
              cx={size / 2}
              cy={size / 2}
              r={radius}
              stroke="#a5cfee"
              strokeWidth="6"
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
              transform={`rotate(-90 ${size / 2} ${size / 2})`}
            />
          </>
        ) : (
          <circle cx={size / 2} cy={size / 2} r={radius + 2} fill="#a5cfee" />
        )}
      </svg>
    </Wrapper>
  );
};

export default TaskCompletionCircle;

const Wrapper = styled.div`
  display: inline-block;
  margin-left: 0; // changed from 8px to 0
  vertical-align: middle;
`;
